import React from 'react'

export const BackItemSVG = ({ ...props }) => {
    return (
        <svg {...props} width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 1L2 10L11 19" stroke="#040503" strokeWidth="2" />
        </svg>




    )
}
